import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { AiOutlineSend } from "react-icons/ai";
import {
  fetchAllUser,
  notifyRead,
  setUnreadMessage,
} from "../actions/adminActions";
import {
  addMessage,
  getConversations,
  getMessages,
} from "../actions/chatActions";
import Loading from "../helpers/Loading";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import { io } from "socket.io-client";
import { SocketData } from "../context/SocketContext";
import UserChatHead from "../components/Admin/UserChatHead";
import Messages from "../components/Chat/Messages";
import withFetchingHandler from "../HOCS/withFetchingHandler";
import LoaderMessage from "../components/LoaderMessage";
const MessageWithFetchingHandler = withFetchingHandler(Messages);
const Chatlist = () => {
  const messageRef = useRef(null);
  const [allUser, setAllUser] = useState(null);
  const [conversation, setConversation] = useState([]);
  const [message, setMessage] = useState("");
  const [allMessages, setAllMessages] = useState(null);
  const [chatHead, setChatHead] = useState(null);
  const [currentChatId, setCurrentChat] = useState(null);

  const dispatch = useDispatch();
  // const [messageToArrive, setMessageToArrive] = useState([]);

  const admin = useSelector((state) => state.adminDetail);
  const chat = useSelector((state) => state.chatDetail);

  const { messageToArrive, socket, readStatus, online } = SocketData();

  useEffect(() => {
    (async function getAllUser() {
      const { friendsData, myData } = await fetchAllUser();

      setAllUser(friendsData);

      dispatch({
        type: "FIRST_RENDER_CHAT_UNREAD",
        payload: myData.unreadMessage,
      });
    })();
  }, [admin.userId, dispatch]);

  useEffect(() => {
    /* current chat is not the sender
    and there is message just arrive
    check if that id === undefined
    then initialize it to 1 else add + 1
     */
    // current Chat is the id of who you currently chatting with
    //if there is message and the message is who you currently chatting with
    //then get the Message else set the message to unread

    //
    async function updateUnreadMessage() {
      await setUnreadMessage({
        senderId: messageToArrive?.sender,

        send: false,
      });
    }
    if (
      messageToArrive &&
      currentChatId === messageToArrive?.sender &&
      conversation?.conversationMembers.includes(messageToArrive?.sender)
    ) {
      setAllMessages((prev) => [...prev, messageToArrive]);
    } else if (messageToArrive) {
      if (
        currentChatId !== messageToArrive?.sender &&
        chat?.unread?.[messageToArrive?.sender] === undefined
      ) {
        dispatch({
          type: "INITIALIZE_SET_UNREAD",
          payload: messageToArrive?.sender,
        });
        // setUnread({ ...unread, [messageToArrive?.sender]: 1 });
        updateUnreadMessage();
      } else {
        dispatch({
          type: "INCREMENT_SET_UNREAD",
          payload: messageToArrive?.sender,
        });
        // setUnread({
        //   ...unread,
        //   [messageToArrive?.sender]: (unread[messageToArrive?.sender] += 1),
        // });
        updateUnreadMessage();
      }
    }
  }, [messageToArrive]);

  // useEffect(() => {
  //   readStatus !== null &&
  //     setUnread({
  //       ...unread,
  //       [readStatus?.receiver]: (unread[readStatus?.receiver] = 0),
  //     });
  // }, [readStatus]);
  const handleSetUnreadMessageCount = (receiverId) => {
    // unread[receiverId] === undefined ? setUnread({...unread, [receiverId] : 0 })
    dispatch({ type: "SET_AS_READ", payload: receiverId });
    //emit that notification has been read
    // receiver
    //sender
    socket.current.emit("notificationRead", {
      receiverId: admin.userId,
      senderId: receiverId,
    });
  };

  useEffect(() => {
    (async function notifyReading() {
      await notifyRead(readStatus);
    })();
  }, [readStatus]);

  const handleCreateConversation = async (id, user, profile) => {
    //set chat head
    setAllMessages(null);

    setChatHead({
      online: online.find((theId) => theId.userId === id) ? true : false,
      user,
      profile,
    });
    setCurrentChat(id);

    const conversationData = await getConversations({
      data: { receiverId: id },
    });
    setConversation(...conversationData);

    const allMessages = await getMessages({ id: conversationData[0]._id });

    setAllMessages(allMessages);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    //if not online direct to database
    if (!chatHead?.online) {
      await setUnreadMessage({
        senderId: admin.userId,
        receiverId: currentChatId,
        send: true,
      });
    }
    socket.current.emit("sendChatMessage", {
      senderId: admin.userId,
      receiverId: currentChatId,
      text: message,
    });

    const sendMessage = {
      conversationId: conversation._id,
      sender: admin.userId,
      text: message,
    };
    await addMessage(sendMessage);
    setAllMessages((prev) => [...prev, sendMessage]);
    setMessage("");
  };

  if (allUser === null) return <Loading />;
  return (
    <div className="chat_list_container">
      <div className="chat_heads_container">
        {allUser.map((userDetail) => {
          const { user, _id, profile } = userDetail;

          return (
            <div
              className="chat_heads_details"
              key={_id}
              onClick={() => handleCreateConversation(_id, user, profile)}
            >
              <UserChatHead
                messageToArrive={messageToArrive?.text}
                profile={profile}
                unread={
                  chat?.unread?.[_id]
                  // ? chat?.unread?.[_id]
                  // : unreadMessage?.[data.userId]
                }
                userId={_id}
                userName={user}
                online={online.find((id) => id.userId === _id)}
                handleSetUnreadMessageCount={handleSetUnreadMessageCount}
              />
            </div>
          );
        })}
      </div>
      <div className="chat_messages_container">
        <div className="head">
          {chatHead?.profile ? (
            <div className="head_detail">
              <img
                className="avatar"
                src={`https://drive.google.com/thumbnail?id=${chatHead.profile}`}
                alt=""
              />{" "}
              <div
                className={
                  chatHead.online ? "username online" : "username offline"
                }
              >
                {chatHead?.user}
              </div>
            </div>
          ) : (
            currentChatId !== null && (
              <div className="head_detail">
                <span className="avatar">{chatHead?.user.substr(0, 1)}</span>
                <div
                  className={
                    chatHead.online ? "username online" : "username offline"
                  }
                >
                  {chatHead?.user}
                </div>
              </div>
            )
          )}
        </div>
        <div className="body">
          {currentChatId ? (
            <MessageWithFetchingHandler
              data={allMessages}
              chatHead={chatHead}
              message={"No messages 🗅"}
            />
          ) : (
            <LoaderMessage message="Let's chat! 👋🏽" />
          )}
        </div>
        <div className="foot">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name=""
              id=""
              value={message}
              disabled={currentChatId === null}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write something..."
            />
            <button type="submit">
              <AiOutlineSend />{" "}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Chatlist;
